import { render, staticRenderFns } from "./ApiMessageBox.vue?vue&type=template&id=f5f75ab4&scoped=true"
import script from "./ApiMessageBox.vue?vue&type=script&lang=js"
export * from "./ApiMessageBox.vue?vue&type=script&lang=js"
import style0 from "./ApiMessageBox.vue?vue&type=style&index=0&id=f5f75ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f75ab4",
  null
  
)

export default component.exports